/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  LockWithdrawalFeeOptions,
  LockWithdrawalFeeStatus200,
  LockWithdrawalFeeStatus400,
  LockWithdrawalFeeStatus401,
  LockWithdrawalFeeStatus403,
  LockWithdrawalFeeStatus404,
  LockWithdrawalFeeStatus409,
  LockWithdrawalFeeStatus410,
  LockWithdrawalFeeStatus500,
  LockWithdrawalFeeStatus503,
} from '../types/LockWithdrawalFee'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { lockWithdrawalFee } from '../clients/lockWithdrawalFee'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const lockWithdrawalFeeMutationKey = () =>
  [{ url: '/v1/web3/withdrawals/:withdrawal_id' }] as const

export function lockWithdrawalFeeMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = lockWithdrawalFeeMutationKey()
  return mutationOptions<
    LockWithdrawalFeeStatus200,
    ResponseErrorConfig<
      | LockWithdrawalFeeStatus400
      | LockWithdrawalFeeStatus401
      | LockWithdrawalFeeStatus403
      | LockWithdrawalFeeStatus404
      | LockWithdrawalFeeStatus409
      | LockWithdrawalFeeStatus410
      | LockWithdrawalFeeStatus500
      | LockWithdrawalFeeStatus503
    >,
    LockWithdrawalFeeOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return lockWithdrawalFee({ ...config, path, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description Redeems a fee quote from GET /v1/web3/withdrawals/fee-quote against an admin-approved withdrawal, holding the quoted fee from the caller's available balance and making the withdrawal eligible for on-chain submission. Restricted to users whose native asset is USDC.
 * @summary Lock the network fee for an approved USDC withdrawal
 * {@link /v1/web3/withdrawals/:withdrawal_id}
 */
export function useLockWithdrawalFee<TContext>(
  options: {
    mutation?: UseMutationOptions<
      LockWithdrawalFeeStatus200,
      ResponseErrorConfig<
        | LockWithdrawalFeeStatus400
        | LockWithdrawalFeeStatus401
        | LockWithdrawalFeeStatus403
        | LockWithdrawalFeeStatus404
        | LockWithdrawalFeeStatus409
        | LockWithdrawalFeeStatus410
        | LockWithdrawalFeeStatus500
        | LockWithdrawalFeeStatus503
      >,
      LockWithdrawalFeeOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? lockWithdrawalFeeMutationKey()

  const baseOptions = lockWithdrawalFeeMutationOptions(config) as UseMutationOptions<
    LockWithdrawalFeeStatus200,
    ResponseErrorConfig<
      | LockWithdrawalFeeStatus400
      | LockWithdrawalFeeStatus401
      | LockWithdrawalFeeStatus403
      | LockWithdrawalFeeStatus404
      | LockWithdrawalFeeStatus409
      | LockWithdrawalFeeStatus410
      | LockWithdrawalFeeStatus500
      | LockWithdrawalFeeStatus503
    >,
    LockWithdrawalFeeOptions,
    TContext
  >

  return useMutation<
    LockWithdrawalFeeStatus200,
    ResponseErrorConfig<
      | LockWithdrawalFeeStatus400
      | LockWithdrawalFeeStatus401
      | LockWithdrawalFeeStatus403
      | LockWithdrawalFeeStatus404
      | LockWithdrawalFeeStatus409
      | LockWithdrawalFeeStatus410
      | LockWithdrawalFeeStatus500
      | LockWithdrawalFeeStatus503
    >,
    LockWithdrawalFeeOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    LockWithdrawalFeeStatus200,
    ResponseErrorConfig<
      | LockWithdrawalFeeStatus400
      | LockWithdrawalFeeStatus401
      | LockWithdrawalFeeStatus403
      | LockWithdrawalFeeStatus404
      | LockWithdrawalFeeStatus409
      | LockWithdrawalFeeStatus410
      | LockWithdrawalFeeStatus500
      | LockWithdrawalFeeStatus503
    >,
    LockWithdrawalFeeOptions,
    TContext
  >
}
